document.addEventListener('DOMContentLoaded', () => {
    const slider = document.getElementById('sqmRange');
    const bubble = document.getElementById('sliderBubble');
    const bubbleContainer = document.getElementById('sliderBubble1');
    const calculatedFilmValue = document.querySelector('.calculation-circle-film .calculation-value');
    const calculatedLinerValue = document.querySelector('.calculation-circle-liner .calculation-value');
    const checkbox = document.getElementById('overlaminateToggle');
    let overLaminateValue = 1;
  
    function updateSliderValue(slider) {
        const value = slider.value;
        const filmBaseValue = slider.getAttribute('data-film-base-value');
        const linerBaseValue = slider.getAttribute('data-liner-base-value');
        bubble.innerText = value + ' sqm';
      
        // Update slider background gradient
        const percent = (value - slider.min) / (slider.max - slider.min);
        slider.style.background = `linear-gradient(to right, #7F1183 0%, #7F1183 ${percent * 100}%, #D9D9D9 ${percent * 100}%, #D9D9D9 100%)`;
      
        // Update bubble position
        const sliderRect = slider.getBoundingClientRect();
        const thumbWidth = 15; // Width of the slider thumb
        
        // Calculate the position of the thumb
        const thumbPosition = percent * (sliderRect.width - thumbWidth) + (thumbWidth / 2);
        
        // Adjust bubble position based on thumb position
        bubble.style.left = `${thumbPosition+2}px`;
      
        // Call the update functions for film and liner values
        const updatedFilmValue = updateFilmValue(value, filmBaseValue, overLaminateValue);
        const updatedLinerValue = updateLinerValue(value, linerBaseValue, overLaminateValue);
        calculatedFilmValue.innerText = updatedFilmValue;
        calculatedLinerValue.innerText = updatedLinerValue;
    }
  
    // Handle checkbox changes
    checkbox.addEventListener('change', function () {
        overLaminateValue = checkbox.checked ? 2 : 1;
        updateSliderValue(slider);
    });
  
    // Initialize on load
    updateSliderValue(slider);
  
    // Update on slider movement
    slider.addEventListener('input', () => updateSliderValue(slider));
    
    // Update on window resize to keep alignment
    window.addEventListener('resize', () => updateSliderValue(slider));
  
    function updateFilmValue(value, filmBaseValue, overLaminateValue) {
        const updatedValue = value/1000 * filmBaseValue * overLaminateValue;
        return updatedValue.toFixed(2);
    }
  
    function updateLinerValue(value, linerBaseValue, overLaminateValue) {
        const updatedValue = value/1000 * linerBaseValue * overLaminateValue;
        return updatedValue.toFixed(2);
    }
  });